import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import { AppContainer, MainContentContainer, BodyContainer,WhiteContainer, AppButton, SchoolsTableStyle} from '../../resources/styling/appStyle';
import { InputAdornment, OutlinedInput, InputLabel, MenuItem, Select,CircularProgress,Grid, Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Link, Modal, Box, Typography, FormControl, TextField, Collapse} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '../../resources/theme/colors';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import groupService from '../../services/api/matGroupService';
import { getAppUrls } from '../../utils/config';
import { toast } from 'react-toastify';
import schoolService from '../../services/api/schoolService';
import { format } from 'date-fns';
import MuiDropDown from '../../components/common/MuiDropDown';
import AuditTrailDetails from '../../components/subscription/AuditTrailDetails';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  FloatingInputLabel,
} from '../../components';
import { PaddingOutlined } from '@mui/icons-material';
import { getApiHookParams } from '../../auth';
import { PRODUCT_DISPLAY_NAMES, PRODUCT_NAMES, EI_TIER_PRODUCT_IDS, enforceSingleEiTier } from '../../utils/Constants';


const { mandy, pictonBlue } = colors;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 3,
};

// const names = [
//   { id: 1, name: 'Main App & Toolkit' },
//   { id: 2, name: 'Pupil Insights' },
//   { id: 3, name: 'Parents Insights' },
//   { id: 4, name: 'Staff Insights' },
//   { id: 5, name: 'Edu Intelligence' },
//   { id: 6, name: 'Pulse' },
// ];

function EditSubscription(props) {
const navigate = useHistory();
    const [activeMatId, setActiveMatId] = useState(null);
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [loadingProduct, setLoadingProduct] = useState(true);
    const [adminDashboardInfo, setAdminDashboardInfo] = useState({});
    const [selectedMatDetails, setMatDetails] = useState(null); // MAT details object
    const [productName, setProductName] = React.useState([]);
    const [FileVal, setFile] = React.useState('');
    const [FileNameVal, setFileName] = React.useState('');
    const [TrancateFileName, setTrancateFileName] = React.useState('');
    const [addloading, setaddLoading] = useState(false);
    const [matSchoolId, setMatSchoolId] = useState([]);
    const [SchoolGroupName, setSchoolGroupName] = useState('');
    const [SubscriptionTerm, setSubscriptionTerm] = useState('');

    const [selectedStartDate, setSelectedStartDate] = React.useState(null);
    const [selectedEndDate, setSelectedEndDate] = React.useState(null);
    // User Story 2: Product chargeability and mid-term detection
    const [productChargeability, setProductChargeability] = React.useState({});
    const [isMidTerm, setIsMidTerm] = React.useState(false);
    const [proRatedAmount, setProRatedAmount] = React.useState(0);
    const [unpaidInvoices, setUnpaidInvoices] = React.useState([]);
    const [showProRatingWarning, setShowProRatingWarning] = React.useState(false);
    // User Story 2: AC 2.2 - Audit trail
    const [auditTrail, setAuditTrail] = React.useState([]);
    const [auditTrailLoading, setAuditTrailLoading] = React.useState(false);
    const [auditTrailExpanded, setAuditTrailExpanded] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { WELLBEING_APP_URL,INSIGHTS_APP_URL,HOME_APP_URL,EI_APP_URL } = getAppUrls();
    
    // WI-434: use the central product list so new tiers + relabels stay in sync. This is the
    // EDIT screen for existing customers, so retired products remain visible/selectable.
    const names = PRODUCT_NAMES;
    const SubscriptionTermLst = [
      { id: 1, name: '1 Year' },
      { id: 2, name: '2 Years' },
      { id: 3, name: '3 Years' },   
    ];
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const queryMatId = params.get('matId');
        const { groupId: apiGroupId } = getApiHookParams();
        const activeMatId = queryMatId || apiGroupId;

        if (!activeMatId) {
          toast.error('Unable to determine MAT ID.');
          setLoading(false);
          setLoadingProduct(false);
          return;
        }

        setLoading(true);
        setLoadingProduct(true);  
        setActiveMatId(activeMatId);

        groupService.getMatById(activeMatId)      
          .then((response) => {
            if (response && response.success && response.data) 
            {
              setAdminDashboardInfo(response);   
              setMatDetails(response.data);    
              //debugger;
              //prepopulate the already subscribed Products
              const matchedNames = response.data.MatSchoolProductsList.map(item => {
                const match = names.find(n => n.id === item.Product);
                return match?.name; // optional chaining in case match is undefined
              }).filter(Boolean); // removes any undefined/null results
              setProductName(matchedNames);                 
              setSelectedStartDate(response.data.MatSubscription.StartDate);
              setSelectedEndDate(response.data.MatSubscription.EndDate);
              
              // User Story 2: AC 2.2 - Initialize product chargeability from backend data
              const chargeabilityMap = {};
              response.data.MatSchoolProductsList.forEach(item => {
                const match = names.find(n => n.id === item.Product);
                if (match?.name) {
                  // AC 2.7: Read actual chargeability from backend, default to true if not available
                  chargeabilityMap[match.name] = item.IsChargeable !== undefined ? item.IsChargeable : true;
                }
              });
              // Also initialize any matched names that might not have chargeability data
              matchedNames.forEach(name => {
                if (!chargeabilityMap.hasOwnProperty(name)) {
                  chargeabilityMap[name] = true; // Default to chargeable if not found in backend
                }
              });
              setProductChargeability(chargeabilityMap);
              
              // User Story 2: Check if subscription is mid-term
              const currentDate = new Date();
              const startDate = new Date(response.data.MatSubscription.StartDate);
              const endDate = new Date(response.data.MatSubscription.EndDate);
              const midTerm = currentDate >= startDate && currentDate < endDate;
              setIsMidTerm(midTerm);
              
              // User Story 2: Get unpaid invoices
              schoolService.GetUnpaidInvoices(0, activeMatId).then((invoiceResponse) => {
                if (invoiceResponse.success && invoiceResponse.data) {
                  setUnpaidInvoices(invoiceResponse.data);
                  if (invoiceResponse.data.length > 0 && midTerm) {
                    setShowProRatingWarning(true);
                  }
                }
              }).catch(err => console.error('Error fetching unpaid invoices:', err));
              
              // User Story 2: AC 2.2 - Get audit trail for subscription
              const subscriptionId = response.data.MatSubscription?.Id;
              if (subscriptionId) {
                setAuditTrailLoading(true);
                schoolService.GetSubscriptionAuditTrail(null, activeMatId, subscriptionId).then((auditResponse) => {
                  if (auditResponse.success && auditResponse.data) {
                    setAuditTrail(auditResponse.data);
                  }
                  setAuditTrailLoading(false);
                }).catch(err => {
                  console.error('Error fetching audit trail:', err);
                  setAuditTrailLoading(false);
                });
              }
                    
              console.log("final Responce",matchedNames)    
              //loadData();            
              setLoading(false);  
              setLoadingProduct(false);        
            } else {
              console.error('Invalid response from getMatById:', response);
              toast.error('Failed to load MAT subscription data. Please try again.');
              setLoading(false);
              setLoadingProduct(false);
            }
          })
          .catch(err => {
            console.error('Error loading MAT subscription data:', err);
            toast.error('Error loading MAT subscription data. Please try again.');
            setLoading(false);
            setLoadingProduct(false);
          });
          // const loadData = async () => {
          //   try {
          //     await new Promise((resolve) => setTimeout(resolve, 400000));        
          //   } catch (err) {       
          //   } finally {}
          // };
                
      }, [location.search]);  

      const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      };

    
      /* Welbee Grid Properties and function starts*/
      const handleSchoolDetails = (id) => {
        // Handle edit action
        console.log('Edit item with ID:', id);
        navigate.push(`/school-detail?schoolId=${id}`)
        // You can open a modal or navigate to an edit page here
      };
    
       /* Welbee Grid Properties and function starts*/
       const handleMatDetails = (id) => {
        // Handle edit action
        console.log('Edit item with ID:', id);
        navigate.push(`/group-detail?matId=${id}`)
        // You can open a modal or navigate to an edit page here
      };
    
      const handleEDUIntellMATclick = (MATId,SchoolId) => { 
        var MatURL= EI_APP_URL; //"https://ei.welbee.co.uk/login";
        window.open(MatURL);
      };
      const handleEDUIntellSchoolclick = (MATId,SchoolId) => {
        var SchoolURL=EI_APP_URL; //"https://ei.welbee.co.uk/login";
        window.open(SchoolURL);
      };
    
      const handleSchoolInsightsclick = (MATId,SchoolId) => {
        var SchoolURL=INSIGHTS_APP_URL; //"https://insights.welbee.co.uk/login";
        window.open(SchoolURL);
      };
      
      const handleMatInsightsclick = (MATId,SchoolId) => {   
        var SchoolURL=INSIGHTS_APP_URL; //"https://insights.welbee.co.uk/login";
        window.open(SchoolURL);    
      };
    
      const handleSchoolWelbeingclick = (MATId,SchoolId) => {
        var SchoolURL=WELLBEING_APP_URL; //"https://s.wellbeing.welbee.co.uk/login";
        window.open(SchoolURL);   
      };
      
      const handleMatWelbeingclick = (MATId,SchoolId,MATToken) => {
        var MATURL=WELLBEING_APP_URL; //"https://s.wellbeing.welbee.co.uk/login";
        window.open(MATURL); 
      };
    
      const handleSchoolHomeclick = (MATId,SchoolId) => {
        // var SchoolURL="https://s.peoplemanagement.welbee.co.uk/login";
        var SchoolURL=HOME_APP_URL; //"https://s.home.welbee.co.uk/login";
        window.open(SchoolURL);    
      };
      
      const handleMatHomeclick = (MATId,SchoolId) => {
        // var MATURL="https://s.peoplemanagement.welbee.co.uk/login";
        var MATURL=HOME_APP_URL; //"https://s.home.welbee.co.uk/login";
        window.open(MATURL);   
      };
      
      const handleDelete = (id) => {
        // Handle delete action
        console.log('Delete item with ID:', id);
        // Update the data state by removing the item
        //setData(data.filter((item) => item.id !== id));
      };
     
      //New School Additional functons
       const [items, setItems] = useState([]);
       const [formData, setFormData] = useState({   
          establishmentName: '',
          numberofpupils: '',
          address3: '',
          urn: '',  
        });
        // Handle input changes
       
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          setFormData({
            ...formData,
            [name]: value
          });
        };
        
        
        const addItem = () => {                 
          if(formData.establishmentName =="")
          {    
            toast.error('Please enter School Name');
          }
          else if(formData.urn=="")
          {    
            toast.error('Please enter a School URN');
          }  
          else
          {
            setaddLoading(true);
            // Create new item object
            //debugger;
            const newItem = {
                Id: Date.now(), // Using timestamp as a simple unique ID
                Name: formData.establishmentName,
                NumberOfPupil: formData.numberofpupils === ""?0:formData.numberofpupils, // Convert string to number
                Address: formData.address3,
                WondeeSchoolUrn:formData.urn,
                File:  FileVal,
                FileName : FileNameVal,
                MatIdVal : activeMatId,
                SchoolProducts:[],
              };            
              // Add to items array
              // setItems([...items, newItem]);
              if(newItem.establishmentName !== '' && newItem.urn !== '')
              {
                setItems([...items, newItem]);
                // Reset form
                const updateProds=productName.map(item=>
                  item==='Main App & Toolkit'?'Main App and Toolkit':item
                );
                //add the add school logic here     
                newItem.SchoolProducts=updateProds;                           
                schoolService.addNewIndividualSchoolPost(newItem).then((response) => {
                  const { success, message } = response;      
                  if (success) 
                  {
                    // User Story 1.3: Generate invoice for subscription if school was created with subscription data
                    // Note: Schools created from EditSubscription may not have subscription data initially
                    // Invoice generation will be handled when subscription is created/updated
                    if (response.data) {
                      // Extract school ID from response
                      const schoolId = response.data?.Id || response.data?.data?.Id || response.data?.id;
                      if (schoolId) {
                        console.log('School created successfully with ID:', schoolId);
                        // Invoice generation will be handled separately when subscription is created
                      }
                    }
                    
                      toast.success('School added successfully');
                      // Reset form
                      setFormData({
                        establishmentName: '',
                        numberofpupils: '',
                        address3: '',
                        urn: ''
                      });
                      setProductName([]);
                      setaddLoading(false);
                  }
                  else 
                  {
                      toast.error(message);
                  }
                });
              }
              else{
                  if(newItem.establishmentName == '')
                  {
                    toast.error('Please enter School Name');
                  }
                  else if(newItem.urn == '')
                {
                    toast.error('Please enter School URN');
                }
              }
            }             
        };

        const subscriptionItems =
            SubscriptionTermLst.map((item) => {
                return (
                <MenuItem key={item.id} value={item.id}>
                    {item.name}
                </MenuItem>
                );
            });
        

        // User Story 2: AC 2.2 - Calculate total subscription amount in real-time
        const calculateTotalAmount = (year1Cost, year2Cost, year3Cost, vatPercent, discount) => {
          const baseCost = parseFloat(year1Cost || 0) + parseFloat(year2Cost || 0) + parseFloat(year3Cost || 0);
          const afterDiscount = baseCost - parseFloat(discount || 0);
          const vatAmount = afterDiscount * (parseFloat(vatPercent || 20) / 100);
          return afterDiscount + vatAmount;
        };

        const handleProductChange = (event) => {
            const {
              target: { value },
            } = event;
            const rawProducts = typeof value === 'string' ? value.split(',') : value;
            // WI-434: only one EI tier may be active at a time.
            const newProducts = enforceSingleEiTier(rawProducts, productName);
            setProductName(newProducts);

            // User Story 2: Initialize chargeability for new products
            const newChargeability = { ...productChargeability };
            newProducts.forEach(product => {
              if (!newChargeability.hasOwnProperty(product)) {
                newChargeability[product] = true; // Default to chargeable
              }
            });
            setProductChargeability(newChargeability);
            
            // User Story 2: Calculate pro-rated amount if mid-term and new products added
            if (isMidTerm && selectedMatDetails?.MatSubscription) {
              const currentDate = new Date();
              const startDate = new Date(selectedMatDetails.MatSubscription.StartDate);
              const endDate = new Date(selectedMatDetails.MatSubscription.EndDate);
              const remainingDays = Math.max(0, Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24)));
              const annualAmount = selectedMatDetails.MatSubscription.Year1Cost || 0;
              const dailyRate = annualAmount / 365;
              const proRated = dailyRate * remainingDays;
              setProRatedAmount(proRated);
              
              if (unpaidInvoices.length > 0 && newProducts.length > productName.length) {
                setShowProRatingWarning(true);
              }
            }
            
            console.log(productName);
          };
          
        // User Story 2: Handle chargeability toggle
        const handleChargeabilityChange = (productName, isChargeable) => {
          setProductChargeability(prev => ({
            ...prev,
            [productName]: isChargeable
          }));
        };


          function setSubscriptionTerms(name) {    
            setSubscriptionTerm(name);
          }          
 return (
  loading===true? (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
    <CircularProgress />
    </div>  
) : !selectedMatDetails || !selectedMatDetails.Id || !selectedMatDetails.MatSubscription ? (
    <AppContainer>
      <SideMenu />
      <MainContentContainer>
        <Header />
        <BodyContainer>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <WhiteContainer sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6" color="error" gutterBottom>
                  Unable to load subscription data
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Please ensure a valid MAT ID is provided in the URL (e.g., ?matId=123)
                </Typography>
                <AppButton color={mandy} onClick={() => navigate.push('/mat-subscription-list')}>
                  Back to MAT Subscriptions
                </AppButton>
              </WhiteContainer>
            </Grid>
          </Grid>
        </BodyContainer>
      </MainContentContainer>
    </AppContainer>
) : (
    <Formik
          initialValues={{
            Id: selectedMatDetails.Id,
            Name: selectedMatDetails.Name,
            FirstName: selectedMatDetails.FirstName,
            LastName: selectedMatDetails.LastName,
            Email: selectedMatDetails.Email,
            School: '',
            SchoolId: 0,
            MatSchoolIds: [],
            GroupName: '',
            Group: '',
            CustomGroup: '',
            Username: '',
            isTestAccount: false,
            File: null,
            FileName: null,
            MatSchoolProducts: '',
            IsMatSubscriptionUpdate: true,    
             

            IsMATSubscription:true,
            IsMultiYear:true,// get value from selection
            SubscriptionTerm: selectedMatDetails.MatSubscription.SubscriptionTerm,// get value from selection
            Year1Cost:selectedMatDetails.MatSubscription.Year1Cost,// get value from selection
            Year2Cost:selectedMatDetails.MatSubscription.Year2Cost,// get value from selection
            Year3Cost:selectedMatDetails.MatSubscription.Year3Cost,// get value from selection
            VatPercentApplied:selectedMatDetails.MatSubscription.VatPercentApplied === 0?20:selectedMatDetails.MatSubscription.VatPercentApplied,// get value from selection
            Discount:selectedMatDetails.MatSubscription.Discount,// get value from selection
            PaymentCurrency:1,// get value from selection
            PaymentMode:1,// get value from selection           
            StartDate:selectedStartDate,
            EndDate:selectedEndDate,       
          }}
          onSubmit={(values, actions) => {
            //debugger;
            const { loaderActions } = props;
            setLoading(true);
            values.MatSchoolIds = matSchoolId;
            //alert(productName)
            if(values.FirstName=='')
            {
                values.FirstName= values.GroupName;
            }
            if(values.LastName=='')
            {
                values.LastName= values.GroupName;
            }
            
            // AC 2.6: Validate dates - end date must be after start date
            if (selectedStartDate && selectedEndDate) {
              const startDate = new Date(selectedStartDate);
              const endDate = new Date(selectedEndDate);
              if (endDate <= startDate) {
                toast.error('Subscription end date must be after the start date.');
                setLoading(false);
                return;
              }
            }
            
            // User Story 2.4: Send product chargeability data to backend
            values.MatSchoolProducts = productName.map(name => ({
              ProductName: name,
              IsChargeable: productChargeability[name] !== false
            }));
            values.MatNewSchoolsList=items;
            values.StartDate=selectedStartDate;
            values.EndDate=selectedEndDate;   
            console.log(values.MatNewSchoolsList);
            //if (values.MatSchoolIds.length === 0) {          
              //toast.error('Please select a valid school.');
            //} 
            // else if (values.selectedProducts.length === 0) {
            //     toast.error('Please select a valid Products.');
            // } 
            //else {           
              //loaderActions.dataLoading(true);
              //debugger;
              groupService.UpdateMatSchoolSubscriptions(values).then((response) => {
                const { success, message } = response;
                //loaderActions.dataLoading(false);
                setLoading(false);
                if (success)
                {
                   // User Story 2.3: Inform user about invoice actions
                   if (isMidTerm && unpaidInvoices.length > 0) {
                     toast.success('Group Subscription updated successfully. Previous unpaid invoices have been voided and a new invoice has been generated with pro-rated amounts.');
                   } else {
                     toast.success('Group Subscription updated successfully');
                   }
                   // Reset warning state
                   setShowProRatingWarning(false);
                   // AC 2.2: Refresh audit trail after successful update
                   if (activeMatId) {
                     const subscriptionId = selectedMatDetails.MatSubscription?.Id;
                     if (subscriptionId) {
                       setAuditTrailLoading(true);
                       schoolService.GetSubscriptionAuditTrail(null, activeMatId, subscriptionId).then((auditResponse) => {
                         if (auditResponse.success && auditResponse.data) {
                           setAuditTrail(auditResponse.data);
                         }
                         setAuditTrailLoading(false);
                       }).catch(err => {
                         console.error('Error refreshing audit trail:', err);
                         setAuditTrailLoading(false);
                       });
                     }
                   }
                }
                else
                {
                    toast.error(message);
                }
              });
            //}
          }}
          // validateOnBlur={false}
          // validateOnChange={true}
          // validationSchema={Yup.object().shape({
          //   GroupName: Yup.string()
          //     .trim()
          //     .max(50, 'Custom group name must be at most 50 characters.')
          //     .required('Custom group name is required.'),
          //   Group: Yup.string().trim().required('Group is required.'),
          //   Name: Yup.string()
          //     .trim()
          //     .max(50, 'Group name must be at most 50 characters.')
          //     .required('Group name is required.'),
          //   Email: Yup.string()
          //     .trim()
          //     .max(60)
          //     .email('Provide email address like example@g.com.')
          //     .required('Email is required.'),           
          // })}
          render={({
            values,
            handleChange,
            touched,
            errors,
            handleSubmit,
            setFieldValue,
          }) => (
            <div>
          <AppContainer>
            <SideMenu />
            <BodyContainer>
              <Header />
              <MainContentContainer>
              {loading===true? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <CircularProgress />
                    </div>  
              ) : (
                <div>
                  {/* Group Detaill */}
                  <Grid container  mt={1}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <h3>Edit Subscription</h3>
                    </Grid>

                    <Grid item xs={12} lg={12} md={12} sm={12}>              
                      <div className='subscription-detail'>
                        <Stack
                          direction='row'
                          spacing={0.8}
                          alignItems='center'
                          justifyContent='space-between'
                        >
                          <div>
                            <Stack direction='row' spacing={0.8} alignItems="center" justifyContent="space-between">
                            <p>
                                <div>
                                    <strong>Subscription Term : {selectedMatDetails.MatSubscription.SubscriptionTerm} years. </strong> (Billed yearly)
                                </div>
                            </p>                        
                            </Stack>
                            <Stack direction='row' spacing={0.8} alignItems="center" justifyContent="space-between">
                            <p>
                                <div>
                                    <strong>Subscription Cost.</strong>
                                </div>
                                {selectedMatDetails.MatSubscription.SubscriptionTerm === 1 ? (
                                    <>                        
                                    <div>
                                        <strong>Year 1 : £{parseInt(selectedMatDetails.MatSubscription.Year1Cost)+((parseInt(selectedMatDetails.MatSubscription.Year1Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>                            
                                    </>
                                ) : selectedMatDetails.MatSubscription.SubscriptionTerm === 2 ? (
                                    <>                        
                                    <div>
                                        <strong>Year 1 : £{parseInt(selectedMatDetails.MatSubscription.Year1Cost)+((parseInt(selectedMatDetails.MatSubscription.Year1Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>
                                    <div>
                                        <strong>Year 2 : £{parseInt(selectedMatDetails.MatSubscription.Year2Cost)+((parseInt(selectedMatDetails.MatSubscription.Year2Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>                           
                                    </>
                                ) : selectedMatDetails.MatSubscription.SubscriptionTerm === 3 ? (
                                    <>                        
                                    <div>
                                        <strong>Year 1 : £{parseInt(selectedMatDetails.MatSubscription.Year1Cost)+((parseInt(selectedMatDetails.MatSubscription.Year1Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>
                                    <div>
                                        <strong>Year 2 : £{parseInt(selectedMatDetails.MatSubscription.Year2Cost)+((parseInt(selectedMatDetails.MatSubscription.Year2Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>
                                    <div>
                                        <strong>Year 3 : £{parseInt(selectedMatDetails.MatSubscription.Year3Cost)+((parseInt(selectedMatDetails.MatSubscription.Year3Cost) )*(parseInt(selectedMatDetails.MatSubscription.VatPercentApplied)/100))}</strong> ({selectedMatDetails.MatSubscription.VatPercentApplied}% VAT Applied)
                                    </div>
                                    </>
                                ) : (
                                "£0"
                                )}   
                            </p>                                                  
                            </Stack>
                            <p>Your License runs from <span>{formatDate(selectedMatDetails.MatSubscription.StartDate)} - {formatDate(selectedMatDetails.MatSubscription.EndDate)}</span></p>
                          </div> 

                          <div className='subscription-links'>
                            <Link href="#" underline="hover" mb={3}>Change to monthly billing</Link>
                            <Link href="#" underline="hover">Cancel subscription renewal</Link>                    
                          </div>                 
                        </Stack>
                        
                      </div>
                    </Grid>
                  </Grid>

                  {/* Registered Schools */}
                  <Grid container  mt={2}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                        <h4>Schools in Group</h4>    
                        <AppButton color={mandy} onClick={handleOpen}>Add School</AppButton>          
                      </Stack>
                    </Grid>
                    <SchoolsTableStyle>
                    <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell>School Name</TableCell>
                        <TableCell>School URN</TableCell>
                        <TableCell>Account Holder</TableCell>
                        <TableCell>Product</TableCell>                      
                        <TableCell>Action</TableCell>                      
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedMatDetails.GroupDirectors[0]?.MatGroup?.Schools.map((detail) => (
                            <TableRow key={detail.Id}>
                                <TableCell>{detail.Name}</TableCell>
                                <TableCell>{detail.WondeeSchoolUrn}</TableCell>
                                <TableCell>{detail.Email}</TableCell>
                                <TableCell>
                                    <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                    {detail.schoolProductsList && detail.schoolProductsList.length > 0 ? (
                                        detail.schoolProductsList.filter((item, index, self) => 
                                            self.findIndex((i) => i.Product === item.Product) === index
                                        ).map((schoolProds) => (
                                            <React.Fragment key={schoolProds.id}>                                                                      
                                            {schoolProds.Product === 1 && (
                                                // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                <AppButton  label="Main App & Toolkit" onClick={() => handleSchoolWelbeingclick(schoolProds.MatId,schoolProds.SchoolId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                            )}
                                            {schoolProds.Product === 2 && (
                                                // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                <AppButton  label="Student Insight" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                            )}
                                            {schoolProds.Product === 3 && (
                                                // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                <AppButton  label="Parents Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                            )}
                                            {schoolProds.Product === 4 && (
                                                // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                <AppButton  label="Staff Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                            )}
                                            {EI_TIER_PRODUCT_IDS.includes(schoolProds.Product) && (
                                                <AppButton  label={PRODUCT_DISPLAY_NAMES[schoolProds.Product]} onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId,schoolProds.SchoolId)} className='edu-chip' size='small'>{PRODUCT_DISPLAY_NAMES[schoolProds.Product]}</AppButton>
                                            )}
                                            {schoolProds.Product === 6 && (
                                                <AppButton  label="Pulse"  className='lparent-chip' size='small'>Pulse</AppButton>
                                            )}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <Chip label="No products available." className='learning-chip' size='small'/>                                                                      
                                    )}                                
                                    </Stack>
                                </TableCell>
                                <TableCell>
                                <Stack direction="row" spacing={0.5}>
                                    {/* <AppButton color='#DE9868'>Home</AppButton> */}                                                                                                                                                                                                    
                                    <AppButton color='#DE9868'  onClick={() => handleSchoolHomeclick(detail.MatGroupId,detail.Id)} >Home</AppButton>                                                                                                                                                            
                                    <AppButton onClick={() => handleSchoolDetails(detail.Id)} color={pictonBlue}>Detail</AppButton>                                                                
                                    <AppButton onClick={() => handleDelete(detail.Id)} color={mandy}>Delete</AppButton> 
                                </Stack>
                                </TableCell>
                            </TableRow>
                        ))}                  
                    </TableBody>
                    </Table>
                </SchoolsTableStyle> 
                
                  </Grid>

                  {/* User Story 2: Pro-rating Warning */}
                  {showProRatingWarning && isMidTerm && unpaidInvoices.length > 0 && (
                    <Grid container mt={3}>
                      <Grid item xs={12}>
                        <Box sx={{ 
                          p: 2, 
                          bgcolor: 'warning.light', 
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor: 'warning.main'
                        }}>
                          <Typography variant="body2" color="warning.dark">
                            <strong>Warning:</strong> Adding products mid-term will void existing unpaid invoices and generate a new invoice with pro-rated amounts. 
                            Estimated pro-rated amount: £{proRatedAmount.toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  )}

                  {/* Products */}
                  <Grid container mt={3}>
                    <Grid item xs={12} lg={12} md={12} sm={12} mb={1}>
                      <h4>Products</h4>
                      <Typography variant="caption" color="text.secondary">
                        Check the box next to each product to mark it as chargeable (default: chargeable)
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>      
                        <InputLabel id="add-products">Select Products</InputLabel>                         
                      {(loadingProduct===true && productName.length <= 0) ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                            <CircularProgress />
                            </div>  
                        ) : (
                        <Select                                    
                          id="add-prodcuts"
                          multiple
                          //labelId='add-products'
                          value={productName}
                          label="Select Products"
                          onChange={handleProductChange}
                          input={<OutlinedInput id="select-multiple-chip" />}
                          renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                  <Chip 
                                    key={value} 
                                    className='schoolname-chip' 
                                    label={`${value} ${productChargeability[value] !== false ? '(Chargeable)' : '(Non-chargeable)'}`}
                                    onDelete={handleDelete}
                                    color={productChargeability[value] !== false ? 'primary' : 'default'}
                                  />
                              ))}
                              </Box>
                          )}
                          //MenuProps={MenuProps}
                        >
                          {names.map((item) => (
                              <MenuItem
                              key={item.id}
                              value={item.name}                                        
                              >
                              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                <span>{item.name}</span>
                                {productName.includes(item.name) && (
                                  <input
                                    type="checkbox"
                                    checked={productChargeability[item.name] !== false}
                                    onChange={(e) => handleChargeabilityChange(item.name, e.target.checked)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginLeft: '10px' }}
                                    title={productChargeability[item.name] !== false ? "Chargeable" : "Non-chargeable"}
                                  />
                                )}
                              </Stack>
                              </MenuItem>
                          ))}
                        </Select>
                       )}
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* User Story 2: AC 2.2 - Audit Trail Section */}
                  <Grid container mt={3}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                        <h4>Subscription Change History (Audit Trail)</h4>
                        <IconButton
                          onClick={() => setAuditTrailExpanded(!auditTrailExpanded)}
                          size="small"
                        >
                          {auditTrailExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </Stack>
                      <Collapse in={auditTrailExpanded}>
                        {auditTrailLoading ? (
                          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <CircularProgress size={24} />
                          </Box>
                        ) : auditTrail && auditTrail.length > 0 ? (
                          <WhiteContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell><strong>Date & Time</strong></TableCell>
                                  <TableCell><strong>Change Type</strong></TableCell>
                                  <TableCell><strong>Changed By</strong></TableCell>
                                  <TableCell><strong>Details</strong></TableCell>
                                  <TableCell><strong>Notes</strong></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {auditTrail.map((entry, index) => (
                                  <TableRow key={entry.Id || index}>
                                    <TableCell>
                                      {entry.ChangedDate ? format(new Date(entry.ChangedDate), 'MMM dd, yyyy HH:mm:ss') : 'N/A'}
                                    </TableCell>
                                    <TableCell>{entry.ChangeType || 'N/A'}</TableCell>
                                    <TableCell>{entry.ChangedBy || 'System'}</TableCell>
                                    <TableCell>
                                      <AuditTrailDetails oldValue={entry.OldValue} newValue={entry.NewValue} />
                                    </TableCell>
                                    <TableCell>
                                      <Typography 
                                        variant="caption" 
                                        color="text.secondary"
                                        sx={{ 
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                          maxWidth: '300px',
                                          whiteSpace: 'normal'
                                        }}
                                      >
                                        {entry.Notes || 'No notes'}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </WhiteContainer>
                        ) : (
                          <WhiteContainer>
                            <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
                              No audit trail entries found.
                            </Typography>
                          </WhiteContainer>
                        )}
                      </Collapse>
                    </Grid>
                  </Grid>

                  {/* Billing Information */}
                  <Grid container mt={3}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <h4 style={{marginBottom: '10px'}}>Billing Information</h4>              
                      <WhiteContainer>
                        <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} justifyContent="space-between">
                          <div>
                            <h4>{selectedMatDetails.Name}</h4>
                            <p>{selectedMatDetails.Email}</p>
                          </div>
                          <div className='subscription-links'>
                            <Link href="#" underline="hover" mb={2}>Billing History</Link>
                            <Link href="#" underline="hover">Change billing information</Link>                    
                          </div>
                        </Stack>
                      </WhiteContainer>
                    </Grid>
                  </Grid>

                  {/* Subscription cost */}
                  <Grid container mt={3}>
                       <Grid item xs={12} lg={6} md={7} sm={12}>
                          <div className='cost-panel'>
                              <div>
                                  <h3>Subscription Cost</h3>
                                  {/* <span><Link>Edit</Link></span> */}
                              </div>
                              <div  style={{paddingTop:'10px'}}>
                                  <div className='label'>Subscription Term</div> 
                                  <FormControl fullWidth sx={{marginTop: 1}}>                                                                                                                                            
                                      <MuiDropDown                                                            
                                          name='SubscriptionTerm'
                                          //label='Subscription Terms'                                                        
                                           value={values.SubscriptionTerm}
                                          //value={selectedMatDetails.MatSubscription.SubscriptionTerm}
                                          onChange={(e) => {
                                              setFieldValue('SubscriptionTerm', e.target.value);                                                      
                                              setSubscriptionTerms(e.target.value);
                                          }}
                                      >
                                          {subscriptionItems}
                                      </MuiDropDown>
                                  </FormControl>
                              </div>                             
                              <div>
                                  <div className='label' style={{paddingTop:'10px'}}>Subscription Schedule</div> 
                                  <div  style={{paddingTop:'15px'}} >
                                    <FormControl>                                                                                                                                            
                                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                          label="Select Start date"
                                           name='StartDate'
                                          value={selectedStartDate}
                                          onChange={(newValue) => setSelectedStartDate(newValue)}
                                          renderInput={(params) => <TextField {...params} />}
                                        />
                                      </LocalizationProvider>
                                    </FormControl>
                                    <FormControl style={{paddingLeft:'30px'}}>    
                                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                          label="Select End date"
                                           name='EndDate'
                                          value={selectedEndDate}
                                          onChange={(newValue) => setSelectedEndDate(newValue)}
                                          renderInput={(params) => <TextField {...params} />}
                                        />
                                      </LocalizationProvider>
                                    </FormControl>
                                  </div>
                              </div>
                              <div className='yearly-cost'>
                                <div>
                                  <div className='label'>Year 1 Cost (£)</div>
                                  <FormControl>
                                    <FloatingInputLabel
                                      label='Year 1 Cost'                                                   
                                      name='Year1Cost'
                                       value={values.Year1Cost}
                                      //value={selectedMatDetails.MatSubscription.Year1Cost}
                                      onChange={handleChange}
                                    />
                                  </FormControl>
                                </div>
                                <div>
                                  <div className='label'>Year 2 Cost (£)</div>
                                  <FormControl>
                                    <FloatingInputLabel
                                      label='Year 2 Cost'                                                   
                                      name='Year2Cost'
                                      value={values.Year2Cost}
                                      //value={selectedMatDetails.MatSubscription.Year2Cost}
                                      onChange={handleChange}
                                    />
                                  </FormControl>
                                </div>
                                <div>
                                  <div className='label'>Year 3 Cost (£)</div>
                                  <FormControl>
                                    <FloatingInputLabel
                                      label='Year 3 Cost'                                                  
                                      name='Year3Cost'
                                      value={values.Year3Cost}
                                      //value={selectedMatDetails.MatSubscription.Year3Cost}
                                      onChange={handleChange}
                                    />
                                  </FormControl>
                                </div>
                                <div>
                                  <div className='label'>Discount (£)</div>
                                  <FormControl>
                                    <FloatingInputLabel
                                      label='Discount'                                                    
                                      name='Discount'
                                      value={values.Discount}
                                      //value={selectedMatDetails.MatSubscription.Discount}
                                      onChange={handleChange}
                                    />
                                  </FormControl>
                                </div>
                                <div>
                                  <div className='label'>VAT 
                                    (%)</div>
                                  <FormControl>
                                    <FloatingInputLabel                                                  
                                      label='Vat (%)'                                                   
                                      name='VatPercentApplied'
                                      value={values.VatPercentApplied}
                                      //value={selectedMatDetails.MatSubscription.VatPercentApplied}
                                      onChange={handleChange}
                                    />
                                  </FormControl>
                                </div>
                              </div>
                              <hr/>
                              <Stack direction="row" justifyContent='space-between' alignItems='center'>
                                  <p><strong>Final Total</strong></p>
                                  <p><strong>£{calculateTotalAmount(values.Year1Cost, values.Year2Cost, values.Year3Cost, values.VatPercentApplied, values.Discount).toFixed(2)}</strong></p>
                              </Stack>
                              {/* User Story 2: AC 2.2 - Show breakdown of calculation */}
                              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                Subtotal: £{((parseFloat(values.Year1Cost || 0) + parseFloat(values.Year2Cost || 0) + parseFloat(values.Year3Cost || 0)) - parseFloat(values.Discount || 0)).toFixed(2)} 
                                (after discount: £{parseFloat(values.Discount || 0).toFixed(2)}) | 
                                VAT ({values.VatPercentApplied || 20}%): £{(((parseFloat(values.Year1Cost || 0) + parseFloat(values.Year2Cost || 0) + parseFloat(values.Year3Cost || 0)) - parseFloat(values.Discount || 0)) * (parseFloat(values.VatPercentApplied || 20) / 100)).toFixed(2)}
                              </Typography>
                          </div>
                      </Grid>
                  </Grid>

                  {/* Payment Details */}
                  <Grid container mt={3}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                      <h4 style={{marginBottom: '10px'}}>Payment Detail</h4>              
                      <WhiteContainer>
                        <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} justifyContent="space-between">
                          <Stack direction="row" spacing={1} alignItems="center">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="40" height="40" rx="4" fill="#E2E2E2"/>
                              <path d="M27.7773 11.1484H12.2227C10.6826 11.1484 9.42969 12.4014 9.42969 13.9414V26.0586C9.42969 27.5986 10.6826 28.8516 12.2227 28.8516H27.7773C29.3174 28.8516 30.5703 27.5986 30.5703 26.0586V13.9414C30.5703 12.4014 29.3174 11.1484 27.7773 11.1484ZM12.2227 13.2969H27.7773C28.1327 13.2969 28.4219 13.586 28.4219 13.9414V15.4453H11.5781V13.9414C11.5781 13.586 11.8673 13.2969 12.2227 13.2969ZM27.7773 26.7031H12.2227C11.8673 26.7031 11.5781 26.414 11.5781 26.0586V17.5938H28.4219V26.0586C28.4219 26.414 28.1327 26.7031 27.7773 26.7031Z" fill="black"/>
                              <path d="M14.5859 22.4062C13.8751 22.4062 13.2969 22.9845 13.2969 23.6953C13.2969 24.4061 13.8751 24.9844 14.5859 24.9844C15.2967 24.9844 15.875 24.4061 15.875 23.6953C15.875 22.9845 15.2967 22.4062 14.5859 22.4062ZM17.1641 22.4062C16.4533 22.4062 15.875 22.9845 15.875 23.6953C15.875 24.4061 16.4533 24.9844 17.1641 24.9844C17.8749 24.9844 18.4531 24.4061 18.4531 23.6953C18.4531 22.9845 17.8749 22.4062 17.1641 22.4062Z" fill="black"/>
                            </svg>                    
                            <span>************1234</span>
                          </Stack>
                          <div className='subscription-links'>
                            <Link href="#" underline="hover">Update payment details</Link>                    
                          </div>
                        </Stack>
                      </WhiteContainer>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} lg={4} md={4} sm={12}></Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12} mt={1} textAlign='right'>
                        <AppButton
                          color={mandy}
                          type='submit'
                          onClick={handleSubmit}
                          >
                          Update Group Subscription
                      </AppButton>                               
                  </Grid>
               </div>
              )} 
              {/* Add School Modal */}
              <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
              >
                  <Box sx={style}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                      Add School 
                  </Typography>
                  <Grid container spacing={1.5} mt={1}>                                
                      <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>
                              <TextField                                            
                                  name='establishmentName'
                                  id='school-name'
                                  label='School Name' 
                                  value={formData.establishmentName}
                                  onChange={handleInputChange}                                            
                              />                                        
                          </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>
                              <TextField                                            
                                  name='address3'
                                  id='address3'
                                  label='Address'       
                                  value={formData.address3}
                                  onChange={handleInputChange}                                             
                              />                                        
                          </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>
                              <TextField                                            
                                  name='urn'
                                  id='urn'
                                  label='Unique Reference Number (URN)'   
                                  value={formData.urn}
                                  onChange={handleInputChange}                                              
                              />                                        
                          </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>
                              <TextField                                            
                                  name='numberofpupils'
                                  id='number-of-pupils'
                                  label='Number of Pupils'       
                                  value={formData.numberofpupils}
                                  onChange={handleInputChange}                                          
                              />                                        
                          </FormControl>
                      </Grid>               
                      <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>      
                          <InputLabel id="multi-select-label2">Select Products</InputLabel>                                  
                              <Select                                    
                              id="add-prodcuts"
                              multiple
                              labelId='multi-select-label2'
                              value={productName}
                              label="Products"
                              onChange={handleProductChange}
                              input={<OutlinedInput id="select-multiple-chip" />}
                              renderValue={(selected) => (
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => (
                                      <Chip key={value} className='schoolname-chip' label={value} onDelete={handleDelete}/>
                                  ))}
                                  </Box>
                              )}
                              //MenuProps={MenuProps}
                              >
                              {names.map((item) => (
                                  <MenuItem
                                  key={item.id}
                                  value={item.name}                                        
                                  >
                                  {item.name}
                                  </MenuItem>
                              ))}
                              </Select>
                          </FormControl>
                      </Grid> 
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                          <FormControl fullWidth>                                                                                                                
                              <OutlinedInput
                                  type='file'
                                  name='file-7[]'
                                  id='file-7'
                                  accept='image/x-png,image/jpeg'
                                  className='inputfile inputfile-6'
                                  data-multiple-caption='{count} files selected'
                                  endAdornment={
                                      <InputAdornment position="end">                                                
                                          <AppButton color={mandy}  className='search-btn'>Upload</AppButton>
                                      </InputAdornment>
                                      }  
                                  onChange={(event) => {
                                  var files = event.target.files;
                                  var file = files[0];
                                  var splitFileName = file.name.split('.');
                                  var imageName = splitFileName[0];
                                  var trancateString =
                                      imageName.length > 23
                                      ? imageName.substr(imageName, 23, 0) + '...'
                                      : file.name;
                                  if (files && file) {
                                      var reader = new FileReader();
                                      reader.onload = function (readerEvt) {
                                      var binaryString = readerEvt.target.result;
                                      setFile(btoa(binaryString));
                                      setFileName(file.name);
                                      setTrancateFileName(trancateString);
                                      };
                                      reader.readAsBinaryString(file);
                                  }
                                  }}                                                
                              />                                                                                                               
                          </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12} sm={12} textAlign='right' mt={1}>
                      {addloading===true? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                      <CircularProgress />
                      </div>  
                      ) : (<AppButton color={mandy} type='submit' onClick={addItem} >Add School</AppButton>)}                    
                  </Grid>
                  </Grid>
                  </Box>
              </Modal>  
              </MainContentContainer>
            </BodyContainer>
          </AppContainer>
      </div>
      )}
        />
 ));
}

export default withRouter(EditSubscription);
